<template>
    <div class="realname-ipt-wrap">
      <base-input-wrap title="修改真实姓名" :disabled="disabled" :showIptWrap="showIptWrap" @close-ipt-wrap="close" @confirm="confirm">
        <base-input v-model="form.realname" ph="真实姓名" :limitLen="15"/>
      </base-input-wrap>
    </div>
</template>

<script>
import baseInputWrap from './base-input-wrap'
import baseInput from './base-input'

export default {
    data() {
        return {
          showIptWrap: false,
          form: {
            realname: ''
          }
        }
    },
    computed: {
      disabled() {
        let isDisabled = false;
        for (let prop in this.form) {
          if (this.form[prop] === '') {
            isDisabled = true;
            break;
          }
        }
        return isDisabled;
      }
    },
    methods: {
      open(options = {}) {
        this.form.realname = options.realname || ''
        this.showIptWrap = true;
      },

      close() {
        this.showIptWrap = false;
      },

      confirm() {
        if (this.realnameLock) return;
        this.realnameLock = true
        this.$fetch.put({
          url: '/user?method=update_realname&realname=' + this.form.realname
        }).then(data => {
          if (data.success) {
            this.openMessage(1, '更换成功');
            this.showIptWrap = false;
            this.$emit('update-user-info');
          }
        }, e => this.openMessage(0, e.error_text || '更换失败'))
        .finally(() => setTimeout(() => this.realnameLock = false, 500));
      }
    },
    components: {
      baseInputWrap,
      baseInput
    }
}
</script>

<style lang="scss" scoped>
.realname-ipt-wrap {
  position: relative;
  z-index: 100;
}
</style>

